
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M23.707.293a1 1 0 00-1.414 0L12 10.586 1.707.293a1 1 0 00-1.414 0 1 1 0 000 1.414L10.586 12 .293 22.293a1 1 0 000 1.414 1 1 0 001.414 0L12 13.414l10.293 10.293a1 1 0 001.414 0 1 1 0 000-1.414L13.414 12 23.707 1.707a1 1 0 000-1.414z"}})])
          )
        }
      }
    